export enum KfmAppItemApplyToType {
  Cart = 0,
  FromTo = 1,
  Custom = 2,
}
